// @flow
import { BoldButton, ItalicButton } from "draft-js-buttons"

import Configuration from "../configuration"

export default () => ({ addInlineTextButton }: Configuration) => {
  addInlineTextButton(BoldButton)
  addInlineTextButton(ItalicButton)
}
